<rt-dropdown>
  @if (header) {
    <rt-dropdown-header>
      {{ header }}
    </rt-dropdown-header>
  }
  <div #scrollWrap rtScrollable class="scroll-wrap">
    @for (item of items; track trackByItem($index, item)) {
      <rt-dropdown-item (click)="select.emit(item.value)">
        @if (item.icon) {
          <rt-icon prefix [name]="item.icon"> </rt-icon>
        }
        <div layout layout-align-items-center>
          {{ item.option }}
          @if (item.badgeTemplate) {
            <ng-container [ngTemplateOutlet]="item.badgeTemplate"></ng-container>
          }
        </div>
      </rt-dropdown-item>
    }
  </div>
</rt-dropdown>
